export { default } from './MessageWithPageLinkContent';
